import { WHITE } from '@/constants/colors';
import { SxProps, Theme } from '@mui/material';

export const railColumnSx = (): SxProps<Theme> => ({
    flexShrink: 0,
    alignSelf: 'flex-start',
    position: 'sticky',
    top: 0,
    height: '100%',
    overflowY: 'auto',
});

export const CALENDAR_RAIL_WIDTH = { xs: 260, xl: 340 };

// The calendar rail's column, collapsed to nothing off the scheduling view.
export const calendarRailColumnSx = (open: boolean): SxProps<Theme> => ({
    ...railColumnSx(),
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: WHITE,
    width: open ? CALENDAR_RAIL_WIDTH : 0,
    overflowX: 'hidden',
    borderLeft: '1px solid',
    borderColor: 'divider',
    transition: 'width 300ms ease-in-out',
});
